import router from '@/router'

export default {
  name: 'AccessPage',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    redirectTo(url) {
      if(url) {
        this.$router.push(url)
      }
    }
  },
  computed: {
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/access/access.component.js